// extracted by mini-css-extract-plugin
export var form = "_g6-0";